import React from 'react';

import { checkUserType, getTodaysDate } from '@utils/Util';

const EODate = ({ eoDate, setEoDate, isEoDateError }) => {
	return (
		<div>
			<label htmlFor="po-number">
				Expected Order Date {!checkUserType('FASHION_DESIGNER') ? '*' : ''}
			</label>
			<input
				className={`${
					checkUserType('FASHION_DESIGNER') ? '' : isEoDateError ? 'common-border-error' : ''
				}`}
				type="date"
				name="eoDate"
				min={getTodaysDate()}
				value={eoDate}
				onChange={(e) => setEoDate(e.target.value)}
			/>
		</div>
	);
};

export default EODate;
